import React, { useState } from "react";
import Scrollspy from "react-scrollspy";
import { Link } from "react-router-dom";

const HeaderLandingMobileApp = () => {
  // For header select menu
  const [click1, setClick1] = useState(false);
  const handleClick1 = () => setClick1(!click1);

  // For Mobile  menu
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 90) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener("scroll", changeBackground);

  return (
    <>
      {/* =============================================
				Theme Main Menu
			==============================================  */}
      <div
        className={
          navbar
            ? "theme-main-menu sticky-menu theme-menu-five fixed"
            : "theme-main-menu sticky-menu theme-menu-five"
        }
      >
        <div className="d-flex align-items-center justify-content-center">
          <div className="logo">
            <Link to="/">
              <img src="images/logo/gotong-royong-50.png" alt="brand" />
            </Link>
          </div>
          {/* End logo */}

          <nav id="mega-menu-holder" className="navbar navbar-expand-lg">
            <div className="container nav-container">
              <div className="mob-header">
                <button className="toggler-menu" onClick={handleClick}>
                  <div className={click ? "active" : ""}>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </button>
              </div>
              {/* End Header */}

              <div
                className="navbar-collapse collapse landing-menu-onepage"
                id="navbarSupportedContent"
              >
                <div className="d-lg-flex justify-content-between align-items-center">
                  <Scrollspy
                    className="navbar-nav  main-side-nav font-gordita"
                    items={[
                      "beranda",
                      "tentang",
                      "fitur",
                      "benefit",
                      "testimoni",
                    ]}
                    currentClassName="active"
                    offset={-90}
                  >
                    <li className="nav-item">
                      <a href="#beranda" className="nav-link">
                        Beranda
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#tentang" className="nav-link">
                        Tentang Kami
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#fitur" className="nav-link">
                        Fitur 
                      </a>
                    </li>

                    <li className="nav-item">
                      <a href="#benefit" className="nav-link">
                        Benefit
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="#testimoni" className="nav-link">
                        Testimoni
                      </a>
                    </li>
                  </Scrollspy>
                </div>
              </div>
            </div>
          </nav>
          {/* End Navbar */}

          <div className="right-widget">
            <ul className="d-flex align-items-center">
              <li>
                <div
                  className={
                    click1
                      ? "dropdown download-btn ms-0 style-two show"
                      : "dropdown download-btn ms-0 style-two"
                  }
                >
                  <button
                    className="dropdown-toggle"
                    onClick={handleClick1}
                    type="button"
                  >
                    Unduh
                  </button>
                  <div
                    className={click1 ? "dropdown-menu  show" : "dropdown-menu"}
                  >
                    <a
                      className="dropdown-item d-flex align-items-center"
                      href="#"
                      onClick={handleClick1}
                    >
                      <img src="images/icon/103.svg" alt="icon" />
                      <span>IOS</span>
                    </a>
                    <a
                      className="dropdown-item d-flex align-items-center"
                      href="#"
                      onClick={handleClick1}
                    >
                      <img src="images/icon/104.svg" alt="icon" />
                      <span>Android</span>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          {/* End right-widget */}
        </div>
      </div>
      {/* /.theme-main-menu */}

      {/* Mobile Menu Start */}
      <div className={click ? "mobile-menu  menu-open" : "mobile-menu"}>
        <div className="logo order-md-1">
          <Link to="/">
            <img src="images/logo/gotong-royong-50.png" alt="brand" />
          </Link>
          <div className="fix-icon text-dark" onClick={handleClick}>
            <img src="images/icon/close.svg" alt="icon" />
          </div>
          {/* Mobile Menu close icon */}
        </div>

        <Scrollspy
          className="navbar-nav  main-side-nav font-gordita"
          items={["beranda", "tentang", "fitur", "berita", "saran"]}
          currentClassName="active"
          offset={-90}
        >
          <li className="nav-item">
            <a href="#beranda" className="nav-link" onClick={handleClick}>
              Beranda
            </a>
          </li>
          <li className="nav-item">
            <a href="#tentang" className="nav-link" onClick={handleClick}>
              Tentang Kami
            </a>
          </li>
          <li className="nav-item">
            <a href="#fitur" className="nav-link" onClick={handleClick}>
              Fitur 
            </a>
          </li>

          <li className="nav-item">
            <a href="#benefit" className="nav-link" onClick={handleClick}>
              Benefit
            </a>
          </li>
          <li className="nav-item">
            <a href="#testimoni" className="nav-link" onClick={handleClick}>
              Testimoni
            </a>
          </li>
        </Scrollspy>
      </div>
      {/* Mobile Menu End */}
    </>
  );
};

export default HeaderLandingMobileApp;
